import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNav = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 12",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			rx: 1,
			width: 16
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			rx: 1,
			width: 16,
			y: 5
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 2,
			rx: 1,
			width: 16,
			y: 10
		})
	]
});
export default SvgNav;
